import React, { Component } from 'react';
import { View, Image, StyleSheet, StatusBar, Keyboard, Linking,
   TouchableOpacity, KeyboardAvoidingView, Platform,  ScrollView, Dimensions, Share, BackHandler, Alert, ImageBackground, TouchableHighlight, 
   PermissionsAndroid, TouchableWithoutFeedback } from 'react-native';
// import Icon from 'react-native-vector-icons/dist/Ionicons';
// import Icons from 'react-native-vector-icons/FontAwesome';
import AsyncStorage from '@react-native-community/async-storage';
// import Icon from 'react-native-vector-icons/dist/FontAwesome'; 
// import Icon from 'react-native-vector-icons/MaterialIcons';
// import { GoogleSignin, GoogleSigninButton, statusCodes } from 'react-native-google-signin';
import { TextInput, Button, Checkbox, Snackbar,Surface } from 'react-native-paper';
// import Colors from '../Colors';
// import Styles from '../UI/styles';
// import FontIcon from 'react-native-vector-icons/FontAwesome';
// import BackHandlerAndroid from './../AndroidBackHandler';
import { connect } from 'react-redux';
import { lostPhone, clearLostPhone } from './../../store/action';
import Toaster from './../../components/snackBar_toaster';
import { Text, Styles} from './../../components/UI-Components';
import BgWrapper from './../../components/bgWrapper';
import BgCircle from './../../components/bgCircle';
import Container from '@material-ui/core/Container';
import zIndex from '@material-ui/core/styles/zIndex';


// import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
// import { deviceHeight, 400, firebaseLogEvent } from './../Utils';
const isIos = Platform.OS === "ios";
// import RazorpayCheckout from 'react-native-razorpay';
// import axios from 'axios';
// import firebase from 'react-native-firebase';
// import { NavigationEvents } from 'react-navigation';
// import OfflineHandler from './../OfflineHandler';
// import Toast, { DURATION } from 'react-native-easy-toast';

const logo = require('./../../assets/rectangle-logo.png')

class LostPhone extends Component {
    state = {
        email: "",
        visible: false,
        snackbarMsg: '',
        emailError: false,
      };



  showToaster = (msg) => {
    this.setState({
      showToast: true,
      toasterMessage: msg
    })
  }

  errorHandler = (fieldName, errVal) => {
    this.setState({
      [fieldName]: errVal
    });
  };
  validateEmail = email => {
    if (/^[.a-z.A-Z.0-9]+@[.a-z.A-Z.0-9]+\.[.A-Za-z]+$/.test(email)) {
      return true;
    } else {
      return false;
    }
  };

  validate = () => {
    const {
      email,
      emailError
    } = this.state;


    if (!this.validateEmail(email)) {
      this.errorHandler("emailError", true);
      return;
    }

    if (!emailError) {
      this.props.lostPhone(this.state.email);
    }
  };

  

  clearAllDataAndLogout = () => {    
    // this.props.dispatchClearRegistation();  
  }

  componentDidUpdate(preProps) {

    if (preProps.response !== this.props.response) {
      if (this.props.response) {
        const toastMsg = this.props.message || "Something Went Wrong..";
        if (!(this.props.response.status === "failure")) {
          this.setState({
            email: ''
          })
        }
        this.refs.toast.show(toastMsg, 3000)
      }
    }
    if (preProps.err !== this.props.err) {
      if (this.props.err) {
        const errInfo = this.props.err || "Something Went Wrong..";
        this.refs.toast.show(errInfo, 1000)
      }
    }
  }





  render() {
    const {
        email,
        emailError
      } = this.state;
    const { err, errInfo, loading, response } = this.props;
    return (

      <div className='loginBox' style={{display: 'flex', justifyContent: 'center', alignItems: 'center',  position: 'relative', overflow: 'hidden' }}>
          <Container maxWidth='lg'>
         
          <div style={{
          //    width: 300 , 
          display: 'flex',
          // // height: 400,
          flexDirection: 'column',
          // padding: 20,
          // paddingBottom: 10,
          // justifyContent: 'center',
          // borderRadius: 5, 
          // // boxShadow: '0px 1px 1px 1px rgba(0,0,0,0.6)',  
          alignItems: 'center', 
        
          }}
            >
                <BgCircle 
                size={30}
                style={{
                  bottom:-150,
                  left: 0,
                  zIndex: 100,
                  overflow: 'hidden'
                }}
                
              />
                <BgCircle 
                size={5}
                style={{
                  top:20,
                  left: '50%',
                  zIndex: 100,
                  overflow: 'hidden'
                }}
                
              />
               <View style={{ 
                flex: 1,
                // marginTop: -80 
               
                
                }}>            
               <View style={{  marginTop: -20, marginBottom: 20, alignItems: 'center'}}>
                    <Text style={{ color: '#222', fontSize: 40,  fontWeight: '600', marginTop: 15 }}>Lost your Phone </Text>
                    <View style={{ flexDirection: 'row', marginTop: 5 }}>
                        <Text style={{ color: '#999b9e', fontSize: 13, }}>
                            {/* OTP sent to  your mobile number or email */}
                            We will send you an One Time Password to your registered mobile number
                        </Text>
                        {/* <Text style={{marginLeft:5,fontSize: 13,}}>{this.props.navigation.getParam('mobile')}</Text> */}
                    </View>
                    </View>
              </View>

              <View style={{ marginTop: 15,  width: '80%' }}>
              <Text style={{ color: "red", marginBottom: 5, fontSize: 12, textAlign: 'right' }}>
                  {emailError && "Enter registered email"}
                </Text>
              </View>

              <View style={{ width: '100%', marginTop: 10, alignSelf: 'center',}}>
                {/* <Icon style={styles.searchIcon}
                  name={isIos ? "ios-phone-portrait" : "md-phone-portrait"}
                  size={30} /> */}
                <TextInput
                  mode="flat"
                  style={[styles.inputBox, {color: Styles.primaryColor, fontSize: 18, fontWeight: 'bold', letterSpacing: 4}]}
                  label="Email address"
                  value={this.state.email}
                  keyboardType="email-address"
                  isFocused={false}
                  onChangeText={value => this.setState({ email: value.trim() })}
                  underlineColor={'#A4A4A4'}
                  theme={{ colors: { placeholder: '#A4A4A4', text: 'rgba(0,0,0,0.7)', primary: Styles.primaryColor, underlineColor: '#A4A4A4', } }}
                  onBlur={() =>
                    this.validateEmail(email)
                      ? this.errorHandler("emailError", false)
                      : this.errorHandler("emailError", true)
                  }
               />

              </View>

             
              <View style={{ width: '70%',  marginBottom: 15, marginTop: 45, justifyContent: 'center', alignItems: 'centers' }}>
                <Button
                  onPress={() => {
                    Keyboard.dismiss();
                    this.validate()
                  }
                  }
                  mode="contained"
                  style={styles.button}
                  disabled={this.props.loading || this.state.buttonDisable ? true : false}
                  uppercase={false}
                  loading={this.props.loading  ? true : false}
                 
                >
                  <Text style={{ fontSize: 16, fontWeight: '600', color: '#000' }}> Send</Text>
                </Button>
             
              </View>
             
           
              {/* <Text style={styles.forgetText}
                onPress={() => this.props.history.push('/LostPhone')}
              >Lost Phone?</Text> */}
            
           
          </div>

            <Toaster 
              show={this.state.showToast}
              message={this.state.toasterMessage}
            />
        
        {/* <Toast
              position='bottom'
              positionValue={Colors.toastPositionValue}
              opacity={1}
              textStyle={{ color: Colors.toastTextColor }}
              style={{
                marginBottom: 50,
                backgroundColor: Colors.toastBgColor,
                paddingHorizontal: Colors.toastPaddingHorizontal,
                borderRadius: 20,
              }}
              ref="toast" /> */}
        </Container>      
      </div>
      
    )
  }
}

const styles = StyleSheet.create({
  statuBarColor: {
    // backgroundColor: Colors.statuBarColor,
  },
  splashBackgroundImage: {
    width: '100%',
    height: '100%',
  },
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 10,
    width: 400,
    // height: deviceHeight
  },
  inputBox: {
    width: '70%',
    backgroundColor: 'transparent',
    alignSelf: 'center'
  },

  button: {
    width: 200,
    borderRadius: 10,
    backgroundColor: '#f9c741',
    // borderRadius: 15,
    borderWidth: 2,
    borderColor: '#fff',
   height: 50, 
   justifyContent: 'center',
   alignItems:'center',
    alignSelf : 'center' 

  },
  fbBtnn: {
    width: '100%',
    backgroundColor: '#BF360C',
    marginVertical: 10,
  },
  buttonText: {
    fontSize: 14,
    color: '#fff',
    textAlign: 'center'
  },
  forgetText: {
    color: '#263238',
    fontSize: 16,
    fontWeight: '500',
    marginTop: 40,
    justifyContent: 'center',
    fontWeight: '600',
    color: '#000'
  },
  _bottomText: {
    marginTop: 'auto',
    color: '#fff',
    fontSize: 16,
    marginBottom: 10
  },
  get bottomText() {
    return this._bottomText;
  },
  set bottomText(value) {
    this._bottomText = value;
  },
  signupText: {
    fontSize: 16,
    marginLeft: 25,
    ...Platform.select({
      android: {
        color: '#fff',
        fontWeight: '700'
      },
      ios: {
        color: '#1a2b63',
      }
    })
  },
  error: {
    borderColor: '#fff',
    borderWidth: 1
  },
  searchSection: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 10
  },
  searchIcon: {
    position: 'absolute',
    right: 15,
    top: 18,
    color: 'rgba(0,0,0,0.6)',
    // marginLeft: 15

  },
  SocialIcon: {
    flexDirection: 'row',
    width: 300,
    justifyContent: 'space-around',
    marginVertical: 25
  },
  facebookIcon: {
    flex: 1,
    borderRadius: 0,
    color: '#3C5A99'
  },
  googleIcon: {
    flex: 1,
    color: '#222'
  },
  ptfrm_text: {
    ...Platform.select({
      android: {
        paddingBottom: 5,
        color: '#fff'
      },
      ios: {
        paddingBottom: 5,
        color: '#fff'

      }
    })
  }
})

const mapStateToProps = state => ({
    loading: state.lostPhone && state.lostPhone.loading,
    err: state.lostPhone && state.lostPhone.err,
    errorInfo: state.lostPhone && state.lostPhone.errorInfo,
    response: state.lostPhone && state.lostPhone.response,
    status: state.lostPhone && state.lostPhone.response && state.lostPhone.response.status,
    message: state.lostPhone && state.lostPhone.response && state.lostPhone.response.message,
})

export default connect(mapStateToProps, { 
    lostPhone, clearLostPhone

})(LostPhone);

// export default Login
